import React, {Component} from 'react';
import assets from "../../../util/assets";
import "./index.css"
import {Col, Row, TabContent, Container} from "reactstrap";
import LabelFormField from "../../../components/LabelFormFields";
import {BROADCASTER, getUserDetail, USER} from "../../../util/account_management";
import {getAgeGroupDiv} from "../../../util/utility";

class UserProfileAboutContainer extends Component {

    render() {

        const email = getUserDetail(this.props,USER,"email");
        const country_code = getUserDetail(this.props,USER,"country_code");
        const phone_number = getUserDetail(this.props,USER,"phone_number");
        const age_group = getUserDetail(this.props,USER,"age_group");

        const user_id = getUserDetail(this.props,USER,"user_id");
        const firstname = getUserDetail(this.props,BROADCASTER,"firstname");
        const lastname = getUserDetail(this.props,BROADCASTER,"lastname");

        return (
            <Row>
                <Col md="6">
                    <LabelFormField label={"User ID"} value={user_id}/>
                    <LabelFormField label={"First Name"} value={firstname}/>
                    <LabelFormField label={"Last Name"} value={lastname}/>
                </Col>
                <Col md="6">
                    <LabelFormField label={"Email"} value={email}/>
                    <LabelFormField label={"Mobile number"} value={`${country_code} ${phone_number}`}/>
                    <LabelFormField label={"Age group"} value={getAgeGroupDiv(age_group, "age-group-24")}/>
                </Col>
            </Row>
        );
    }
}

UserProfileAboutContainer.propTypes = {};

export default UserProfileAboutContainer;
